module.exports = __webpack_public_path__ + "img/Sort(Button).1197ec21.svg";